import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import toast from "react-hot-toast";
import { deleteGreetingOccasionCategory } from "../actions";
import GreetingOccasionSubcategoryService from "../../../../services/GreetingOccasionSubcategoryService";
import { GreetingOccasionSubcategory } from "../../../../models";
import { deleteGreetingOccasionSubCategory } from "../actions/GreetingOccasionSubcategory";

export function CreateGreetingOccasionCategory() {
  return (
    <Link to={"/admin/greeting-occasion-categories/create"}>
      <Button className="mt-4">
        Create Greeting Occasion Category
        <Icon icon={PlusIcon} label="Create Greeting Occasion Category" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateGreetingOccasionCategory({ id }: { id: string }) {
  return (
    <Link to={`/admin/greeting-occasion-categories/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteGreetingOccasionCategory({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteGreetingOccasionCategoryWithId = deleteGreetingOccasionCategory.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this greeting occasion category?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteGreetingOccasionCategoryWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate("/admin/greeting-occasion-categories?reload=true", { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}

export function DeleteGreetingOccasionSubcategoryButton({ greetingOccasionSubcategory }: { greetingOccasionSubcategory: GreetingOccasionSubcategory }) {
  const navigate = useNavigate();
  const deleteGreetingOccasionSubcategoryWithId = deleteGreetingOccasionSubCategory.bind(null, greetingOccasionSubcategory.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this greeting occasion subcategory?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteGreetingOccasionSubcategoryWithId, {
    success: false,
  });
  useEffect(()=>{
    if(state.success){
      toast.success("Greeting occasion subcategory deleted successfully");
      navigate(`/admin/greeting-occasion-categories/edit/${greetingOccasionSubcategory.greetingOccasionCategoryId}?reload=${Date.now()}`, { replace: true });
    }

  },[state])

  return (
    <form action={formAction} onSubmit={handleSubmit}>
    <IconButton 
      label="Delete" 
      icon={TrashIcon}      
      loading={isPending} 
      />
      </form>
  );
}

